import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const assessmentStatusService = {
    getAll,
    getAllAssessmentStatuses,
    getAllAssessmentStatusesByIds,
    addAssessmentStatus,
    updateAssessmentStatus,
    deleteAssessmentStatus,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/assessment/statuses/getAllStatuses/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllAssessmentStatuses() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/assessment/statuses/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllAssessmentStatusesByIds(statusIds) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/assessment/statuses/getAllByIds/${statusIds}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addAssessmentStatus(newAssessmentStatus) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newAssessmentStatus),
    };

    const response = await fetch(
        `${config.oat_api_url}/assessment/statuses/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateAssessmentStatus(assessmentStatusItem, assessmentStatusId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(assessmentStatusItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/assessment/statuses/update/${assessmentStatusId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteAssessmentStatus(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/assessment/statuses/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
